/**
 * Determines whether the key pressed in a KeyboardEvent is a number key.
 *
 * @param event the KeyboardEvent to be checked
 * @returns whether the key pressed in the KeyboardEvent is a number key
 */
export function isNumberKey(event) {
    return !isNaN(Number(event.key));
}
//# sourceMappingURL=phone-number-field-utilities.js.map